import { useSelector } from 'react-redux';
import { IState } from 'store';
import { IConfigApplicationProps } from 'store/modules/config';
import { IProductCarouselProps } from 'store/modules/product';

interface ProductImageProps {
  item: IProductCarouselProps;
  haveSelo: boolean;
}

export default function ProductImage({ item, haveSelo }: ProductImageProps) {
  const { ultraDescontao } = useSelector<IState, IConfigApplicationProps>(
    state => state.config.config,
  );

  return (
    <div className={`product-image${haveSelo ? ' have-selo' : ''}`}>
      {item.ultraPremio && (
        <img
          src="/images/card-icons/ultrapremio.png"
          alt="Ultrapremio"
          className="Selo UltraPremio"
        />
      )}

      {item.seloCIMED && (
        <img src="/images/card-icons/selo_cimed.svg" className="Selo CIMED" />
      )}

      {item.ultraDesconto && ultraDescontao.estaVigente && (
        <img
          src={ultraDescontao.seloVigenteVitrineUrl}
          className="Selo Ultradesconto"
        />
      )}

      <img loading="lazy" src={item.imagemUrl} alt={item.nome} />
    </div>
  );
}
